import { render, staticRenderFns } from "./CrazyGamesLinkButton.vue?vue&type=template&id=e1ef4fc8&"
import script from "./CrazyGamesLinkButton.vue?vue&type=script&lang=ts&"
export * from "./CrazyGamesLinkButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports